var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33375 19.5617C0.96697 19.5617 0.65302 19.431 0.391901 19.1698C0.130634 18.9087 0 18.5947 0 18.2279V1.33375C0 0.978084 0.133375 0.666876 0.400125 0.400125C0.666876 0.133375 0.978084 0 1.33375 0H11.0701C11.4369 0 11.7509 0.130559 12.0122 0.391678C12.2733 0.652945 12.4039 0.96697 12.4039 1.33375V4.66813C12.6706 4.71259 12.8929 4.83818 13.0708 5.04491C13.2486 5.25179 13.3375 5.48616 13.3375 5.74802V7.40232C13.3375 7.68389 13.2486 7.92841 13.0708 8.13588C12.8929 8.34335 12.6706 8.46932 12.4039 8.51378V18.2279C12.4039 18.5947 12.2733 18.9087 12.0122 19.1698C11.7509 19.431 11.4369 19.5617 11.0701 19.5617H1.33375ZM1.33375 18.2279H11.0701V1.33375H1.33375V18.2279ZM6.66876 4.24577C6.80213 4.1124 6.86882 3.95679 6.86882 3.77896C6.86882 3.60113 6.80213 3.44552 6.66876 3.31215C6.53538 3.17877 6.37978 3.11209 6.20194 3.11209C6.02411 3.11209 5.86851 3.17877 5.73513 3.31215C5.60176 3.44552 5.53507 3.60113 5.53507 3.77896C5.53507 3.95679 5.60176 4.1124 5.73513 4.24577C5.86851 4.37915 6.02411 4.44584 6.20194 4.44584C6.37978 4.44584 6.53538 4.37915 6.66876 4.24577Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.2db8580eae30e6d0d7965279a56a7a0c.svg";
export { ForwardRef as ReactComponent };